import Position from "../types/PositionType";
import { Canvas } from "./Canvas";

export class PlacementTiles {
  private canvasObj: Canvas;
  private _position: Position;
  private _size: number;
  private _isOccupied: boolean;

  constructor(position: Position, canvas: Canvas) {
    this._position = position;
    this._size = 64;
    this.canvasObj = canvas;
    this._isOccupied = false;
  }

  // Getter and setter for position
  public get position(): Position {
    return this._position;
  }

  public set position(position: Position) {
    this._position = position;
  }

  // Getter and setter for size
  public get size(): number {
    return this._size;
  }

  public set size(size: number) {
    this._size = size;
  }

  // Getter and setter for isOccupied
  public get isOccupied(): boolean {
    return this._isOccupied;
  }

  public set isOccupied(isOccupied: boolean) {
    this._isOccupied = isOccupied;
  }
}
